module.exports = __webpack_public_path__ + "img/11_noff_open_L1.36357d45.svg";